/**
 * @generated SignedSource<<c41044e05bfefbad2a940e791a10037e>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { DateTime } from "@/common/relayCustomScalar";
import { FragmentRefs } from "relay-runtime";
export type CompetitionLeaderboardFragment$data = {
  readonly id: string;
  readonly stage: {
    readonly hasLeaderboard: boolean;
    readonly leaderboard: {
      readonly edges: ReadonlyArray<{
        readonly cursor: string;
        readonly node: {
          readonly entity: {
            readonly id: string;
            readonly username: string;
            readonly " $fragmentSpreads": FragmentRefs<"EntityProfilePicFragment">;
          };
        };
        readonly score: number;
        readonly validatedAt: DateTime;
      }>;
    };
  } | null | undefined;
  readonly " $fragmentType": "CompetitionLeaderboardFragment";
};
export type CompetitionLeaderboardFragment$key = {
  readonly " $data"?: CompetitionLeaderboardFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"CompetitionLeaderboardFragment">;
};

import CompetitionLeaderboardFragmentPaginationQuery_graphql from './CompetitionLeaderboardFragmentPaginationQuery.graphql';

const node: ReaderFragment = (function(){
var v0 = [
  "stage",
  "leaderboard"
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": 10,
      "kind": "LocalArgument",
      "name": "count"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "cursor"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "stage"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "count",
        "cursor": "cursor",
        "direction": "forward",
        "path": (v0/*:: as any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "count",
          "cursor": "cursor"
        },
        "backward": null,
        "path": (v0/*:: as any*/)
      },
      "fragmentPathInResult": [
        "node"
      ],
      "operation": CompetitionLeaderboardFragmentPaginationQuery_graphql,
      "identifierInfo": {
        "identifierField": "id",
        "identifierQueryVariableName": "id"
      }
    }
  },
  "name": "CompetitionLeaderboardFragment",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "stage",
          "variableName": "stage"
        }
      ],
      "concreteType": "CompetitionStage",
      "kind": "LinkedField",
      "name": "stage",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "hasLeaderboard",
          "storageKey": null
        },
        {
          "alias": "leaderboard",
          "args": null,
          "concreteType": "SubmissionRankingConnection",
          "kind": "LinkedField",
          "name": "__CompetitionLeaderboardFragment_leaderboard_connection",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "SubmissionRankingSubmissionEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "score",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "validatedAt",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Submission",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": null,
                      "kind": "LinkedField",
                      "name": "entity",
                      "plural": false,
                      "selections": [
                        (v1/*:: as any*/),
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "username",
                          "storageKey": null
                        },
                        {
                          "args": [
                            {
                              "kind": "Literal",
                              "name": "thumbnail",
                              "value": true
                            }
                          ],
                          "kind": "FragmentSpread",
                          "name": "EntityProfilePicFragment"
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    (v1/*:: as any*/)
  ],
  "type": "Competition",
  "abstractKey": null
};
})();

(node as any).hash = "9a964036767d6f0e716f81f33af18b3d";

export default node;
